const unfocusStyle = document.createElement("STYLE");

export default function unfocus() {
  document.getElementsByTagName("HEAD")[0].appendChild(unfocusStyle);

  document.addEventListener("mousedown", () => {
    unfocusStyle.innerHTML = "::-moz-focus-inner{border:0 !important;}:focus{outline: none !important;}";
  });
  document.addEventListener("keydown", () => {
    unfocusStyle.innerHTML = "";
  });
}
